import { SET_CHECKOUT_CREDIT_SETTINGS, SET_CHECKOUT_SETTINGS, SET_CHECKOUT_SHIPPING_ISCOMPLETE, SET_GLOBAL_ADDRESS_CONFIG, SET_GLOBAL_ISB3USER, SET_GLOBAL_ISPENDING, SET_GLOBAL_LOADING_STAGE, SET_GLOBAL_QUOTEID, SET_INVOICE_CONFIG, SHOW_GLOBAL_ERROR } from '../actionTypes'

type LoadingStage = string

declare interface GlobalAction {
  type: string
  payload: any
}

 interface CreditType {
  disableBtn: boolean,
  creditHold: boolean,
  errorType: number,
  B2BCreditCurrency: string,
  isEnabled: boolean,
 }

export const setGlobalLoadingStage = (stage: LoadingStage): GlobalAction => ({
  type: SET_GLOBAL_LOADING_STAGE,
  payload: stage,
})

export const showGlobalError = (error: Error): GlobalAction => ({
  type: SHOW_GLOBAL_ERROR,
  payload: error,
})

export const setGlobalIsB3User = (state: boolean): GlobalAction => ({
  type: SET_GLOBAL_ISB3USER,
  payload: state,
})

export const setGlobalIsPending = (state: boolean): GlobalAction => ({
  type: SET_GLOBAL_ISPENDING,
  payload: state,
})

export const setCheckoutSettings = (state: boolean): GlobalAction => ({
  type: SET_CHECKOUT_SETTINGS,
  payload: state,
})

export const setCheckoutCreditConfig = (state: CreditType): GlobalAction => ({
  type: SET_CHECKOUT_CREDIT_SETTINGS,
  payload: state,
})


export const setCheckoutShippingIsComplete = (state: boolean): GlobalAction => ({
  type: SET_CHECKOUT_SHIPPING_ISCOMPLETE,
  payload: state,
})

export const setGlobalQuoteId = (state: boolean): GlobalAction => ({
  type: SET_GLOBAL_QUOTEID,
  payload: state,
})

export const setInvoiceConfig = (state: any): GlobalAction => ({
  type: SET_INVOICE_CONFIG,
  payload: state,
})

export const setAddressConfig = (state: boolean): GlobalAction => ({
  type: SET_GLOBAL_ADDRESS_CONFIG,
  payload: state,
})
